/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
// import slick from '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';
import GSAP from '../vendors/gsap.min';
import ScrollTrigger from '../vendors/ScrollTrigger.min';
import '../vendors/dropdown';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );

		if ( jQuery( '.header-section' ).hasClass( 'header-section-light' ) ) {
			jQuery( '.header-section' ).removeClass( 'header-section-light' );
			jQuery( '.header-section' ).addClass( 'is-initially-light' );
		}

		if ( jQuery( window ).width() > 1179 ) {
			if ( jQuery( '.header-section' ).hasClass( 'is-initially-light' ) && jQuery( '.header-section' ).hasClass( 'shrink' ) ) {
				jQuery( '.header-section' ).on( 'mouseleave', function() {
					jQuery( this ).removeClass( 'header-section-light' );
				} );
			}

			if ( jQuery( '.header-section' ).hasClass( 'location-button-blue' ) && jQuery( '.header-section' ).hasClass( 'shrink' ) ) {
				jQuery( '.header-section' ).on( 'mouseleave', function() {
					jQuery( this ).removeClass( 'location-button-white' );
				} );
			}
		}

		if ( jQuery( '.header-section' ).hasClass( 'location-button-white' ) ) {
			jQuery( '.header-section' ).removeClass( 'location-button-white' );
			jQuery( '.header-section' ).addClass( 'location-button-blue' );
		}
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );

		if ( jQuery( '.header-section' ).hasClass( 'is-initially-light' ) ) {
			jQuery( '.header-section' ).addClass( 'header-section-light' );
			jQuery( '.header-section' ).removeClass( 'is-initially-light' );
		}

		if ( jQuery( '.header-section' ).hasClass( 'location-button-blue' ) ) {
			jQuery( '.header-section' ).addClass( 'location-button-white' );
			jQuery( '.header-section' ).removeClass( 'location-button-blue' );
		}

		if ( jQuery( window ).width() > 1179 ) {
			if (
				jQuery( '.header-section' ).hasClass( 'header-section-light' ) && ! jQuery( '.header-section' ).hasClass( 'shrink' )
			) {
				jQuery( '.header-section' ).on( 'mouseover', function() {
					jQuery( this ).removeClass( 'header-section-light' );
				} );

				jQuery( '.header-section' ).on( 'mouseleave', function() {
					jQuery( this ).addClass( 'header-section-light' );
				} );
			}
		}

		if ( jQuery( window ).width() > 1179 ) {
			if (
				jQuery( '.header-section' ).hasClass( 'location-button-white' ) && ! jQuery( '.header-section' ).hasClass( 'shrink' )
			) {
				jQuery( '.header-section' ).on( 'mouseover', function() {
					jQuery( this ).removeClass( 'location-button-white' );
				} );

				jQuery( '.header-section' ).on( 'mouseleave', function() {
					jQuery( this ).addClass( 'location-button-white' );
				} );
			}
		}
	}
} );

jQuery( function() {
	const userAgent = window.navigator.userAgent.toLowerCase();
	const body = jQuery( 'body' );

	// Detect OS
	if ( userAgent.indexOf( 'windows' ) !== -1 ) {
		body.addClass( 'windows' );
	} else if ( userAgent.indexOf( 'macintosh' ) !== -1 || userAgent.indexOf( 'mac os x' ) !== -1 ) {
		body.addClass( 'mac' );
	} else if ( userAgent.indexOf( 'iphone' ) !== -1 || userAgent.indexOf( 'ipad' ) !== -1 ) {
		body.addClass( 'ios' );
	} else if ( userAgent.indexOf( 'android' ) !== -1 ) {
		body.addClass( 'android' );
	}

	// Detect Safari
	if ( userAgent.indexOf( 'safari' ) !== -1 && userAgent.indexOf( 'chrome' ) === -1 ) {
		body.addClass( 'safari' );
	}

	jQuery.noConflict();

	// For Parents
	jQuery( '.menu-item-has-children > a' ).focus( function() {
		jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
	} ).blur( function() {
		jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
	} );

	// For children
	jQuery( '.sub-menu a' ).focus( function() {
		jQuery( this ).parents( '.sub-menu' ).addClass( 'focused' );
	} ).blur( function() {
		jQuery( this ).parents( '.sub-menu' ).removeClass( 'focused' );
	} );

	/** For Mega Dropdown */

	// For Parents
	jQuery( '.menu-item-has-children > a' ).focus( function() {
		jQuery( this ).siblings( 'ul' ).addClass( 'focused' );
	} ).blur( function() {
		jQuery( this ).siblings( 'ul' ).removeClass( 'focused' );
	} );

	// For children
	jQuery( '.mega-menu-links a' ).focus( function() {
		jQuery( this ).parents( '.mega-menu-links' ).parent().addClass( 'focused' );
	} ).blur( function() {
		jQuery( this ).parents( '.mega-menu-links' ).parent().removeClass( 'focused' );
	} );

	if ( window.innerWidth < 1004 ) {
		if ( jQuery( '.banner-homepage-tabs' ).length > 0 ) {
			let isAdmin = 0;

			if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
				isAdmin = 32;

				if ( jQuery( window ).width() < 783 ) {
					isAdmin = 46;
				}
			}

			const toggleTopbar = jQuery( '.header-section' ).outerHeight() + isAdmin + 3;
			const heightForLeaveTabsPin = jQuery( '.tabbed-repeater-tabs-content-area' ).outerHeight();

			gsap.to( '.banner-homepage-tabs', {
				duration: 1,
				scrollTrigger: {
					trigger: '.banner-homepage-tabs',
					start: `top ${ toggleTopbar }px  top`,
					end: `${ heightForLeaveTabsPin }`,
					// markers: true,
					pin: true,
					pinSpacing: false,
				},
			} );
		}
	}

	/**
	 * Toggle menu for mobile
	 */
	// accessible sub menu

	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	jQuery.noConflict();

	if ( jQuery( '.header-section' ).length > 0 ) {
		if ( jQuery( window ).width() > 1003 ) {
			jQuery(
				'.header-nav ul > li,.footer__nav li,.footer__bottom--nav li'
			).on( 'mouseenter', function() {
				jQuery( this )
					.closest( 'ul' )
					.find( '> li' )
					.not( this )
					.addClass( 'menu-item-hovered' );
			} );

			jQuery(
				'.header-nav ul > li, .footer__nav li,.footer__bottom--nav li'
			).on( 'mouseleave', function() {
				jQuery( this )
					.closest( 'ul' )
					.find( '> li' )
					.not( this )
					.removeClass( 'menu-item-hovered' );
			} );

			jQuery( '.js-search-open' ).on( 'click', function( e ) {
				e.stopPropagation();
				jQuery( this )
					.closest( '.header-btns__search' )
					.find( '.header-search__popup' )
					.addClass( 'js-show-search-bar' );
				jQuery( this ).addClass( 'js-show-search-button-active' );
				jQuery( 'html' ).css( 'overflow', 'hidden' ); // Apply inline style to hide overflow
				jQuery( '.header-section' ).addClass( 'no-light-header' );
			} );

			jQuery( '.header-search__close' ).on( 'click', function() {
				jQuery( '.header-search__popup' ).removeClass( 'js-show-search-bar' );
				jQuery( '.js-search-open' ).removeClass( 'js-show-search-button-active' );
				jQuery( 'html' ).css( 'overflow', '' ); // Remove inline style to reset overflow
				jQuery( '.header-section' ).removeClass( 'no-light-header' );
			} );

			jQuery( document ).on( 'keydown', function( e ) {
				if ( e.keyCode === 27 ) {
					jQuery( '.header-search__popup' ).removeClass( 'js-show-search-bar' );
					jQuery( '.js-search-open' ).removeClass( 'js-show-search-button-active' );
					jQuery( 'html' ).css( 'overflow', '' ); // Remove inline style to reset overflow
					jQuery( '.header-section' ).removeClass( 'no-light-header' );
				}
			} );
		}
	}
	if ( jQuery( '.icon-grid-area' ).length > 0 ) {
		jQuery( '.icon-grid-area' ).each( function() {
			const array = [];
			let html = '';
			jQuery( this )
				.find( '.icon-grid__items--item' )
				.each( function() {
					array.push(
						'<div class="icon-grid__items--item">' +
							jQuery( this ).html() +
							'</div>'
					);
				} );

			if ( jQuery( window ).width() > 1003 ) {
				const LogoSize = 3;
				const logochunk = [];
				for ( let i = 0; i < array.length; i += LogoSize ) {
					logochunk.push( array.slice( i, i + LogoSize ) );
				}
				for ( const key in logochunk ) {
					const element = logochunk[ key ];
					html += '<div class="icon-grid__items three-columns ">';
					for ( const key in element ) {
						const el = element[ key ];
						html += el;
					}
					html += '</div>';
				}
			} else if (
				jQuery( window ).width() <= 1003 &&
				jQuery( window ).width() > 747
			) {
				const LogoSize = 2;
				const logochunk = [];
				for ( let i = 0; i < array.length; i += LogoSize ) {
					logochunk.push( array.slice( i, i + LogoSize ) );
				}
				for ( const key in logochunk ) {
					const element = logochunk[ key ];
					html += '<div class="icon-grid__items two-columns ">';
					for ( const key in element ) {
						const el = element[ key ];
						html += el;
					}
					html += '</div>';
				}
			} else if ( jQuery( window ).width() <= 748 ) {
				const LogoSize = 1;
				const logochunk = [];
				for ( let i = 0; i < array.length; i += LogoSize ) {
					logochunk.push( array.slice( i, i + LogoSize ) );
				}
				for ( const key in logochunk ) {
					const element = logochunk[ key ];
					html += '<div class="icon-grid__items  ">';
					for ( const key in element ) {
						const el = element[ key ];
						html += el;
					}
					html += '</div>';
				}
			}

			jQuery( this ).html( html );
		} );
	}
	if ( jQuery( '.footer-section' ).length > 0 ) {
		jQuery( '.socials__item ,.site-links-item' ).on(
			'mouseenter',
			function() {
				jQuery( '.socials__item ,.site-links-item' )
					.not( this )
					.addClass( 'social-hovered' );
			}
		);

		jQuery( '.socials__item ,.site-links-item' ).on(
			'mouseleave',
			function() {
				jQuery( '.socials__item ,.site-links-item' )
					.not( this )
					.removeClass( 'social-hovered' );
			}
		);
	}

	jQuery( '.js-clear-input' ).on( 'click', function() {
		jQuery( 'html' ).css( 'overflow', '' ); // Remove inline style to reset overflow
		jQuery( 'header' ).removeClass( 'no-light-header' );

		jQuery( this )
			.closest( '.h-contain-search-field' )
			.find( 'input[type="search"]' )
			.val( '' );
		jQuery( '.ajax-search-container' ).empty();
		jQuery( '.hide-spacer' ).hide();
		jQuery( '.search-results-ctn' ).empty();
		jQuery( this ).siblings( 'input' ).removeClass( 'input-has-value' );
		jQuery( '.header-search__popup' ).removeClass( 'js-show-search-bar' );
		jQuery( '.js-search-open' ).removeClass( 'js-show-search-button-active' );
		jQuery( 'body' ).removeClass( 'focused' );
		jQuery( '.header-section' ).removeClass( 'no-light-header' );
		localStorage.removeItem( 'websiteValue' );
		localStorage.removeItem( 'locationNumber' );
		localStorage.removeItem( 'locationNumberText' );
		jQuery( '#header-btns__locations--button' ).find( '.has-stored-lable' ).text( 'Find a Location' );
	} );

	jQuery(
		'input[type="text"],input[type="email"],input[type="tel"],textarea,input[type="search"],input[type="number"]'
	).on( 'input', function() {
		const inputValue = jQuery( this ).val();
		if ( inputValue !== '' ) {
			jQuery( this ).addClass( 'input-has-value' );
		} else {
			jQuery( this ).removeClass( 'input-has-value' );
		}
	} );

	jQuery( 'select' ).on( 'change', function() {
		if ( jQuery( this ).val() !== '' ) {
			jQuery( this ).addClass( 'input-has-value' );
		} else {
			jQuery( this ).removeClass( 'input-has-value' );
		}
	} );
	jQuery( '.header-btns__locations' ).on( 'mouseenter', function() {
		if ( jQuery( this ).hasClass( 'is-active' ) ) {
			jQuery( this ).addClass( 'is-active-dropdown' );
		}
	} );

	jQuery( '.header-btns__locations' ).on( 'mouseleave', function() {
		if ( jQuery( this ).hasClass( 'is-active' ) ) {
			jQuery( this ).removeClass( 'is-active-dropdown' );
		}
	} );

	jQuery( '.video__popup' ).magnificPopup( {
		type: 'iframe',
		fixedContentPos: true,
		overflowY: 'hidden',
	} );

	if ( jQuery( '.js-class-child' ).length > 0 ) {
		jQuery( '.js-class-child a' ).mouseover( function() {
			jQuery( this ).parents( '.js-class-parent' ).addClass( 'link-hover' );
		} );
		jQuery( '.js-class-child a' ).mouseleave( function() {
			jQuery( this ).parents( '.js-class-parent' ).removeClass( 'link-hover' );
		} );
		jQuery.noConflict();
	}

	if ( jQuery( 'body' ).hasClass( 'single-post' ) ) {
		const headings = jQuery( '.resource-detail-content__inner h2' );
		const headingList = jQuery( '.heading-lists' );

		let count = 1;

		headings.each( function() {
			const id = jQuery( this ).text().trim().toLowerCase().replace( /[^a-zA-Z0-9 ]/g, '' ).replace( /\s/g, '-' );
			jQuery( this ).attr( 'id', id );

			if ( jQuery( this ).text() !== '' ) {
				const listItem = jQuery( '<li></li>' );
				const anchor = jQuery( '<a></a>' );
				anchor.attr( 'href', '#' + id ).html( jQuery( this ).text() );
				listItem.append( anchor );
				headingList.append( listItem );
				count++;
			}
		} );

		// Hide table of content if it's empty
		if ( headingList.html().trim() === '' ) {
			jQuery( '.rsc-slide__title.p4' ).hide();
			jQuery( '.table-of-content-list' ).hide();
			jQuery( '.heading-lists' ).hide();
		}

		function isInViewport( elem ) {
			const bounding = elem[ 0 ].getBoundingClientRect();
			return bounding.top >= 0 && bounding.top <= ( window.innerHeight || document.documentElement.clientHeight );
		}

		jQuery( window ).on( 'scroll', function() {
			const y = jQuery( this ).scrollTop();
			headings.each( function() {
				const href = '#' + jQuery( this ).attr( 'id' );
				const targetElement = jQuery( href );
				if ( targetElement.length > 0 ) {
					const viewPort = targetElement.offset().top - 260;
					if ( y >= viewPort ) {
						jQuery( '.heading-lists li a' ).removeClass( 'active' );

						jQuery( '.heading-lists li a[href="' + href + '"]' ).addClass( 'active' );
					}
				}
			} );
		} );

		// Handle click event on heading list links
		jQuery( '.heading-lists li a' ).on( 'click', function( event ) {
			event.preventDefault();
			const targetId = jQuery( this ).attr( 'href' );
			const targetHeading = jQuery( targetId );

			if ( targetHeading.length ) {
				// Remove 'active' class from all links
				jQuery( '.heading-lists li a' ).removeClass( 'active' );

				// Add 'active' class to clicked link
				jQuery( this ).addClass( 'active' );

				// Scroll to target heading
				targetHeading[ 0 ].scrollIntoView( { behavior: 'smooth' } );
			}
		} );
	}

	if ( jQuery( '.scrolling-content' ).length > 0 ) {
		   function isInViewportScrolling( element ) {
			const rect = element.getBoundingClientRect();
			return (
				rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) &&
            rect.right <= ( window.innerWidth || document.documentElement.clientWidth )
			);
		}

		function updateActiveLink() {
			jQuery( '.scrolling-content__column--single' ).each( function( index, column ) {
				if ( isInViewportScrolling( column ) ) {
					jQuery( '.scrolling-content__jump-links a' ).removeClass( 'active' );
					const targetId = jQuery( column ).attr( 'id' );
					jQuery( '.scrolling-content__jump-links a[href="#' + targetId + '"]' ).addClass( 'active' );
				}
			} );
		}

		jQuery( window ).scroll( updateActiveLink );

		updateActiveLink();
	}

	jQuery( document ).mouseup( function( e ) {
		const container = jQuery(
			'.team__detail,.popup-ctn,.magnific-popup-inner,.get-started-content,.header-search__popup'
		);
		if (
			! container.is( e.target ) &&
				container.has( e.target ).length === 0
		) {
			jQuery( '.team__detail,.popup-ctn' ).removeClass( 'show' );
			jQuery( 'body' ).removeClass( 'show' );

			if ( ! jQuery( 'html' ).hasClass( 'overflow-normal' ) ) {
				jQuery( 'html' ).css( 'overflow-y', 'scroll' );
			}

			jQuery( 'html' ).removeClass( 'html-overflow-hidden' );
		}
	} );

	jQuery( '.js-team-popup' ).on( 'click', function() {
		jQuery( '.js-team-popup-detail' ).removeClass( 'show' );
		jQuery( 'body' ).removeClass( 'show' );
		const id = jQuery( this ).attr( 'href' );
		jQuery( id ).addClass( 'show' );
		jQuery( 'body' ).addClass( 'show' );
		jQuery( 'html' ).addClass( 'show-sidebar' );
		jQuery( 'html' ).addClass( 'html-overflow-hidden' );
		jQuery( '.menu-btn' ).addClass( 'active mobile-popup-close' );
	} );

	jQuery( '.team-popup-close-btn, .popup-background,.popup-close' ).on( 'click', function() {
		jQuery( '.js-team-popup-detail,.get-started-content' ).removeClass( 'show' );
		jQuery( 'body' ).removeClass( 'show' );
		jQuery( 'html' ).removeClass( 'show-sidebar' );
		jQuery( '.popup-background ' ).removeClass( 'show-sidebar' );

		jQuery( 'html' ).removeClass( 'html-overflow-hidden' );
	} );

	const currentUrl = window.location.href;
	const idParam = currentUrl.split( '#' )[ 1 ];
	if ( 'get-started-form' === idParam ) {
		jQuery( '.get-started-content' ).addClass( 'show' );
		jQuery( 'body' ).addClass( 'show' );
		jQuery( 'html' ).addClass( 'html-overflow-hidden' );
		jQuery( '.menu-btn' ).addClass( 'active mobile-popup-close' );
	}

	jQuery( '.getStartedPopupButton,a[href="#get-started-form"]' ).on( 'click', function() {
		jQuery( '.get-started-content' ).addClass( 'show' );
		jQuery( 'body' ).addClass( 'show' );
		jQuery( 'html' ).addClass( 'html-overflow-hidden' );
		jQuery( '.menu-btn' ).addClass( 'active mobile-popup-close' );
	} );

	if ( jQuery( 'body' ).hasClass( 'show' ) ) {
		jQuery( '.menu-btn' ).on( 'click', function() {
			jQuery( 'html, body' ).removeClass( 'no-overflow' );
			jQuery( 'html, body' ).removeClass( 'no-overflow' );
			jQuery( '.nav-overlay' ).removeClass( 'open' );
		} );
	}

	jQuery( '.js-open-button' ).on( 'click', function() {
		jQuery( '.menu-btn' ).addClass( 'active mobile-popup-close' );
	} );

	if ( jQuery( '.faq-block' ).length > 0 ) {
		jQuery( '.faqs__item .faqs__item--head' ).on( 'click', function() {
			if ( jQuery( this ).hasClass( 'active' ) ) {
				jQuery( this ).removeClass( 'active' );
				jQuery( this ).closest( '.faqs__item' ).removeClass( 'active' );
				jQuery( this ).siblings( '.faqs__item--content' ).slideUp( 300 );
			} else {
				jQuery( '.faqs__item .faqs__item--head' ).removeClass( 'active' );
				jQuery( '.faqs__item' ).removeClass( 'active' );
				jQuery( this ).closest( '.faqs__item' ).addClass( 'active' );
				jQuery( '.faqs__item--content' ).slideUp( 300 );
				jQuery( this ).addClass( 'active' );
				jQuery( this ).siblings( '.faqs__item--content' ).slideDown( 300 );
			}
		} );
		jQuery.noConflict();
	}

	if ( jQuery( window ).width() < 748 ) {
		jQuery( '.page-section,.post-399' ).find( '.ctn:last-child' ).css( 'padding-bottom', ' 36px' );
		jQuery( '.form-cta' ).parents( '.wrapper' ).parents( '.ctn' ).css( 'padding-bottom', ' 36px' );
	}
	// jQuery( 'select[id^=input_7]' ).select2();
	if ( jQuery( window ).width() < 1003 ) {
		if ( jQuery( '.scrolling-content' ) ) {
			jQuery( '.scrolling-column .scrolling-column__head' ).on( 'click', function() {
				if ( jQuery( this ).hasClass( 'active' ) ) {
					jQuery( this ).removeClass( 'active' );
					jQuery( this ).closest( '.scrolling-column' ).removeClass( 'active' );
					jQuery( this ).siblings( '.scrolling-column__content' ).slideUp( 300 );
				} else {
					jQuery( '.scrolling-column .scrolling-column__head' ).removeClass( 'active' );
					jQuery( '.scrolling-column' ).removeClass( 'active' );
					jQuery( this ).closest( '.scrolling-column' ).addClass( 'active' );
					jQuery( '.scrolling-column__content' ).slideUp( 300 );
					jQuery( this ).addClass( 'active' );
					jQuery( this ).siblings( '.scrolling-column__content' ).slideDown( 300 );
				}
			} );
			jQuery.noConflict();
		}
	}

	if ( jQuery( '.stats__single--head' ).length > 0 ) {
		const a = [];
		function isElementInViewport( el ) {
			const rect = el.getBoundingClientRect();
			return (
				rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <=
				( window.innerHeight || document.documentElement.clientHeight ) &&
			rect.right <=
				( window.innerWidth || document.documentElement.clientWidth )
			);
		}
		if ( jQuery( '.stats__single--head' ).length > 0 ) {
			jQuery( window ).scroll( function() {
				jQuery( '.stats__single--head' ).each( function( index ) {
					if ( ! a[ index ] && isElementInViewport( this ) ) {
						jQuery( this )
							.find( '.counter' )
							.each( function() {
								const $this = jQuery( this ),
									countTo = $this.attr( 'data-number' );
								jQuery( {
									countNum: $this.text(),
								} ).animate(
									{
										countNum: countTo,
									},
									{
										duration: 2000,
										easing: 'swing',
										step() {
											$this.text(
												Math.ceil(
													this.countNum
												).toLocaleString( 'en' )
											);
										},
										complete() {
											$this.text(
												Math.ceil(
													this.countNum
												).toLocaleString( 'en' )
											);
										},
									}
								);
							} );
						a[ index ] = true;
					}
				} );
			} );
		}
		jQuery.noConflict();
	}

	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );

	jQuery( 'h1.d1' ).each( function() {
		const lineHeight = parseInt( jQuery( this ).css( 'line-height' ) );
		const height = jQuery( this ).height();
		const lineCount = height / lineHeight;

		if ( jQuery( window ).width() > 1003 ) {
			if ( lineCount >= 2 ) {
				jQuery( this ).removeClass( 'd1' );
				jQuery( this ).addClass( 'd2' );
				// console.log( 'print mobile value' );
			}
		}
		if ( jQuery( window ).width() < 1004 ) {
			if ( lineCount >= 3 ) {
				jQuery( this ).removeClass( 'd1' );
				jQuery( this ).addClass( 'd2' );
				// console.log( 'print mobile value' );
			}
		}
	} );

	jQuery( document ).on( 'click', '.header-nav .menu-item span', function() {
		const link = jQuery( this ).parents( 'li' );

		// link.siblings( '.active' ).removeClass( 'active' ).find( 'ul' ).slideUp();

		if ( link.hasClass( 'active' ) ) {
			link.removeClass( 'active' );
			link.parents( 'ul' ).removeClass( 'disabled-menu' );
			// link.find( 'ul' ).slideUp();
		} else {
			link.addClass( 'active' );
			link.parents( 'ul' ).addClass( 'disabled-menu' );
			// link.find( 'ul' ).slideDown();
		}
	} );

	jQuery( document ).on( 'click', '.submenu-icon', function() {
		jQuery( this ).parents( '.header-nav' ).addClass( 'active-ul' );
		jQuery( this ).parent().find( '.mega-menu' ).toggleClass( 'active-mega-menu' );
		jQuery( this ).parent().find( 'ul' ).toggleClass( 'active-dropdown' );
	} );

	jQuery( document ).on( 'click', '.menu-back-link', function() {
		jQuery( this ).parents( '.header-nav' ).removeClass( 'active-ul' );
	} );

	jQuery( document ).on( 'click', '.menu-btn', function() {
		jQuery( '.header-nav' ).removeClass( 'active-ul' );
	} );

	if ( jQuery( window ).width() < 1180 ) {
		jQuery( '#menu-header-menu .mega-dropdown-menu' ).each( function() {
			const firstATagText = jQuery( this ).closest( 'li' ).find( 'a:first' ).text();
			const menuBackLink = jQuery( '<div class="menu-back-link"></div>' ).append( jQuery( '<span>' ).text( firstATagText ) ).insertBefore( jQuery( this ).find( '.mega-menu__inner' ) );
			menuBackLink.on( 'click', function() {
				jQuery( this ).parent().removeClass( 'active-mega-menu' );
			} );
		} );
		jQuery( '.main-menu-item.menu-item-has-children' ).each( function() {
			const firstATagText = jQuery( this ).find( 'a:first' ).text();
			const menuBackLink = jQuery( '<li class="menu-back-link"></li>' ).append( jQuery( '<span>' ).text( firstATagText ) ).prependTo( jQuery( this ).find( 'ul' ) );
			menuBackLink.on( 'click', function() {
				jQuery( this ).parent().removeClass( 'active-dropdown' );
			} );
		} );
	}

	jQuery( document ).on( 'click', '.dump-button', function() {
		jQuery( this ).siblings( '.dump-container' ).toggle();
	} );

	// jQuery( '.js-icon-grid-slider' ).slick( {
	// 	dots: false,
	// 	nav: true,
	// 	infinite: false,
	// 	speed: 500,
	// 	slidesToShow: 2,
	// 	slidesToScroll: 1,
	// 	variableWidth: true,
	// 	touchThreshold: 150,
	// 	responsive: [
	// 		{
	// 			breakpoint: 747,
	// 			settings: {
	// 				slidesToShow: 1,
	// 			},
	// 		},
	// 	],
	// } );

	// let prevSlideIndex = 0;

	// jQuery( '.js-icon-grid-slider' ).on( 'afterChange', function( event, slick, currentSlide, nextSlide ) {
	// 	const $slides = jQuery( '.js-icon-grid-slider .slick-slide' );
	// 	if ( currentSlide > prevSlideIndex ) {
	// 		$slides.eq( prevSlideIndex ).addClass( 'prev-slide' );
	// 	}
	// 	prevSlideIndex = currentSlide;
	// 	$slides.eq( currentSlide ).removeClass( 'prev-slide' );
	// } );

	if ( jQuery( '.logo-grid' ).length > 0 ) {
		const array = [];
		let html = '';
		jQuery( '.logo-grid' )
			.find( '.logo-grid__item ' )
			.each( function() {
				array.push(
					'<div class="logo-grid__item d-flex">' +
						jQuery( this ).html() +
						'</div>'
				);
			} );

		if ( jQuery( window ).width() > 1003 ) {
			const LogoSize = 4;
			const logochunk = [];
			for ( let i = 0; i < array.length; i += LogoSize ) {
				logochunk.push( array.slice( i, i + LogoSize ) );
			}
			for ( const key in logochunk ) {
				const element = logochunk[ key ];
				html += '<div class="logo-grid__row ">';
				for ( const key in element ) {
					const el = element[ key ];
					html += el;
				}
				html += '</div>';
			}
		} else if (
			jQuery( window ).width() <= 1003 &&
			jQuery( window ).width() > 747
		) {
			const LogoSize = 3;
			const logochunk = [];
			for ( let i = 0; i < array.length; i += LogoSize ) {
				logochunk.push( array.slice( i, i + LogoSize ) );
			}
			for ( const key in logochunk ) {
				const element = logochunk[ key ];
				html += '<div class="logo-grid__row ">';
				for ( const key in element ) {
					const el = element[ key ];
					html += el;
				}
				html += '</div>';
			}
		} else if ( jQuery( window ).width() <= 748 ) {
			const LogoSize = 2;
			const logochunk = [];
			for ( let i = 0; i < array.length; i += LogoSize ) {
				logochunk.push( array.slice( i, i + LogoSize ) );
			}
			for ( const key in logochunk ) {
				const element = logochunk[ key ];
				html += '<div class="logo-grid__row ">';
				for ( const key in element ) {
					const el = element[ key ];
					html += el;
				}
				html += '</div>';
			}
		}

		jQuery( '.logo-grid' ).html( html );
	}

	if ( jQuery( '.glossary-block' ).length > 0 ) {
		if ( jQuery( window ).width() > 1003 ) {
			const liClicked = false;
			const navID = '.glossary-jumplinks';

			jQuery( window ).scroll( function() {
				const y = jQuery( this ).scrollTop();
				jQuery( navID + ' ul li a' ).each( function() {
					const href = jQuery( this ).attr( 'href' );
					const targetElement = jQuery( href );
					if ( targetElement.length > 0 ) {
						const viewPort = targetElement.offset().top - 260;
						if ( y >= viewPort ) {
							if ( ! liClicked ) {
								jQuery( navID + ' ul li' ).removeClass( 'active' );
								jQuery( this ).parent().addClass( 'active' );
							}
						}
					}
				} );
			} );

			jQuery( navID + ' ul li a' ).click( function( e ) {
				const href = jQuery( this ).attr( 'href' );
				const targetElement = jQuery( href );
				if ( targetElement.length > 0 ) {
					jQuery( navID + ' ul li' ).removeClass( 'active' );
					jQuery( this ).parent().addClass( 'active' );
				}
			} );
		}

		if ( jQuery( window ).width() < 1004 ) {
			const navID = '.glossary-jumplinks';
			const dropdownID = 'glossary-dropdown';
			let liClicked = false;

			// Create and insert the dropdown menu
			const $dropdown = jQuery( '<select id="' + dropdownID + '" class="glossary-dropdown"></select>' );
			jQuery( navID ).before( $dropdown );

			// Populate the dropdown with options based on the existing links
			jQuery( navID + ' ul li a' ).each( function() {
				const href = jQuery( this ).attr( 'href' );
				const text = jQuery( this ).text().trim();
				const $option = jQuery( '<option></option>' ).val( href ).text( text );
				$dropdown.append( $option );
			} );

			// Handle change event on the dropdown menu
			$dropdown.change( function() {
				const href = jQuery( this ).val();
				const targetElement = jQuery( href );
				if ( targetElement.length > 0 ) {
					liClicked = true;
					jQuery( navID + ' ul li' ).removeClass( 'active' );
					jQuery( `${ navID } ul li a[href="${ href }"]` ).parent().addClass( 'active' );
					jQuery( 'html, body' ).animate( { scrollTop: targetElement.offset().top - 260 }, 500, function() {
						liClicked = false;
					} );
				}
			} );

			// Handle scroll event to synchronize the active link with scrolling
			jQuery( window ).scroll( function() {
				const y = jQuery( this ).scrollTop();
				jQuery( navID + ' ul li a' ).each( function() {
					const href = jQuery( this ).attr( 'href' );
					const targetElement = jQuery( href );
					if ( targetElement.length > 0 ) {
						const viewPort = targetElement.offset().top - 260;
						if ( y >= viewPort ) {
							if ( ! liClicked ) {
								jQuery( navID + ' ul li' ).removeClass( 'active' );
								jQuery( this ).parent().addClass( 'active' );
								$dropdown.val( href );
							}
						}
					}
				} );
			} );
		}
	}

	jQuery.noConflict();

	if ( jQuery( window ).width() > 1003 ) {
		if ( jQuery( '.js-service-teaser-slider .service-teaser__items--item h3.heading-5' ).length > 0 ) {
			function setEqualHeight() {
				let maxHeight = 0;
				jQuery( '.js-service-teaser-slider .service-teaser__items--item h3.heading-5' ).each( function() {
					const thisHeight = jQuery( this ).outerHeight();
					if ( thisHeight > maxHeight ) {
						maxHeight = thisHeight;
					}
				} );
				jQuery( '.js-service-teaser-slider .service-teaser__items--item h3.heading-5' ).css( 'height', maxHeight + 'px' );
			}
			setEqualHeight();
		}
	}
	jQuery.noConflict();

	/**
	 * Load More Script
	 */

	if ( jQuery( window ).width() < 1004 ) {
		if ( jQuery( '.team-members-block' ).length > 0 ) {
			jQuery( '.team-member__single' ).slice( 0, 6 ).show();
			jQuery( '#js-load-more-button' ).click( function( e ) {
				jQuery( '.team-member__single:hidden' ).slice( 0, 4 ).fadeIn( 'slow' );
				if ( jQuery( '.team-member__single:hidden' ).length == 0 ) {
					jQuery( '#js-load-more-button' ).hide();
				}
			} );
		}

		if ( jQuery( '.js-service-teaser-slider' ).length > 0 ) {
			jQuery( '.js-service-teaser-slider .service-teaser__items--item' ).slice( 0, 3 ).show();
			jQuery( '#js-load-more-button-services' ).click( function( e ) {
				jQuery( '.service-teaser__items--item:hidden' ).slice( 0, 3 ).fadeIn( 'slow' );

				if ( jQuery( '.service-teaser__items--item:hidden' ).length == 0 ) {
					jQuery( '#js-load-more-button-services' ).hide();
				}
			} );
		}
	}

	/**
	 * Pagination Tooltip
	 */

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( document ).on( 'mouseover', '.pagination__tooltip', function() {
			jQuery( this )
				.parent()
				.find( '.pages-links' )
				.css( { opacity: 1, visibility: 'visible' } );
		// .css( { opacity: 1, visibility: 'visible' } );
		} );

		jQuery( document ).on( 'mouseleave', '.pagination__tooltip', function() {
			jQuery( this )
				.parent()
				.find( '.pages-links' )
				.css( { opacity: 0, visibility: 'hidden' } );
		} );
	}
	jQuery.noConflict();

	if ( jQuery( '.form-cta' ).length > 0 ) {
		jQuery( '.form-cta' )
			.closest( '.wrapper' )
			.parent( 'section' )
			.addClass( 'is-bottom-shape-normal' );

		const checkRightHeight = jQuery( '.form-cta__column--right' ).outerHeight() + 'px';
		jQuery( '.form-cta' ).css( 'min-height', checkRightHeight );
	}

	jQuery( '.tabbed-repeater__tabs .form-cta__column--tabs ul li button' ).on( 'click', function() {
		window.scrollTo( { top: 300, behavior: 'smooth' } );
	} );

	jQuery( '.form-cta__column--tabs ul li button' ).on( 'click', function() {
		const tabTarget = jQuery( this ).data( 'tab-target' );
		jQuery( '.form-cta__column--tabs ul li button' ).removeClass( 'current' );
		jQuery( this ).addClass( 'current' );
		jQuery( '.form-cta__column--tabs ul li button[data-tab-target="' + tabTarget + '"]' ).addClass( 'current' );

		// Hide all elements with the class, then fade in the target
		jQuery( '.form-cta__tabs-content-item, .get-started-popup-content, .tabbed-content' ).hide();
		jQuery( tabTarget ).fadeIn( '1000' ).addClass( 'current' );
	} );

	if ( jQuery( '[data-tab-target=".tab-part-careers"]' ).hasClass( 'current' ) ) {
		jQuery( 'body' ).addClass( 'new-class' );
	}
	jQuery( '.form-cta__column--tabs ul li:first-child button' ).on( 'click', function() {
		jQuery( '#location-search' ).attr( 'placeholder', 'Enter care location ZIP code' );
		jQuery( '#location-search-input-mobile' ).attr( 'placeholder', 'Enter care location ZIP code' );
	} );
	jQuery( '.form-cta__column--tabs ul li:nth-child(2) button' ).on( 'click', function() {
		jQuery( '#location-search' ).attr( 'placeholder', 'Enter your location ZIP code' );
		jQuery( '#location-search-input-mobile' ).attr( 'placeholder', 'Enter your location ZIP code' );
	} );

	if ( jQuery( '#location-search' ).length > 0 ) {
		if ( jQuery( window ).width() > 1180 ) {
			jQuery( document ).on( 'click', '#location-search', function() {
				jQuery( '.banner-search' ).addClass( 'location-search-focused' );
				jQuery( '.banner-search .all-button-area' ).show( );
			} ).on( 'mouseleave focusout', 'li.has-mega-dropdown', function() {
				jQuery( this ).removeClass( 'current' );
			} ).on( 'mouseover', function( e ) {
				const container = jQuery( '.banner-search' );
				if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
					jQuery( '.banner-search' ).removeClass( 'location-search-focused' );
					jQuery( '.banner-search .all-button-area' ).hide( );
				}
			} );
		} else if ( jQuery( window ).width() < 1180 ) {
			jQuery( document ).on( 'mouseenter focus', '#location-search', function( e ) {
			//   jQuery('.mega-dropdown').removeClass('active');
				if ( e.type === 'mouseenter' ) {
					jQuery( '.banner-search' ).addClass( 'location-search-focused' );
					jQuery( '.banner-search .all-button-area' ).show( );
				}
			} ).on( 'mouseleave focusout', 'li.has-mega-dropdown', function() {
				jQuery( this ).removeClass( 'current' );
			} ).on( 'mouseover', function( e ) {
				const container = jQuery( '.banner-search' );
				if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
					jQuery( '.banner-search' ).removeClass( 'location-search-focused' );
					jQuery( '.banner-homepage-bottom .all-button-area' ).hide( );
				}
			} );
		}
		// jQuery( '#location-search' ).on( 'focus', function() {
		// 	jQuery( '.banner-search' ).addClass( 'location-search-focused' );
		// 	jQuery( '.banner-search .all-button-area' ).show( );
		// 	// if ( jQuery( this ).val() === '' ) {
		// 	// 	jQuery( '.banner-search' ).addClass( 'location-search-focused' );
		// 	// 	jQuery( '.banner-search .all-button-area' ).show( );
		// 	// }
		// } );
		// jQuery( '#location-search' ).on( 'blur', function() {
		// 	jQuery( '.banner-search' ).removeClass( 'location-search-focused' );
		// 	jQuery( '.banner-search .all-button-area' ).hide( );
		// } );
	}

	if ( jQuery( '.service-teaser__tabs' ).length > 0 ) {
		jQuery( '.career-tabs .service-teaser__tabs--item a' ).on( 'click', function( event ) {
			event.preventDefault(); // Prevent the default link behavior
			const tabId = jQuery( this ).attr( 'href' );

			// Hide all tabs content, then fade in the target
			jQuery( '.career-tabs__content' ).hide();
			jQuery( tabId ).fadeIn( 800 ).addClass( 'current' );

			// Remove 'current' class from all tabs, then add it to the clicked one
			jQuery( '.career-tabs .service-teaser__tabs--item a' ).removeClass( 'current' );
			jQuery( this ).addClass( 'current' );
		} );
	}

	if ( jQuery( '.cta-section__sliders' ).length > 0 ) {
		class MarqueeSlider {
			constructor( { el, reverse } ) {
				this.el = el;
				this.reverse = reverse; // Indicates whether the animation should be reversed
				this.marqueeAnimation = [
					{ transform: 'translateX(0)' },
					{ transform: 'translateX(calc(-100% - var(--gap, 0)))' },
				];
				this.marqueeTiming = {
					duration: this.el.dataset.duration * 10000, // Adjust the multiplier to change the speed
					direction: this.reverse ? 'reverse' : 'normal',
					iterations: Infinity,
				};
				this.animations = [];
				this.SLOWDOWN_RATE = 0.2;
				this.isMobile = this.checkIfMobile();

				this.cloneMarqueeGroup();
				this.init();
			}

			checkIfMobile() {
				return window.innerWidth <= 768; // You can adjust the width as needed for mobile detection
			}

			init() {
				// console.log('Initializing marquee animations');
				this.animations = []; // Reset animations array
				for ( const m of this.marquee__groups ) {
					const animation = m.animate( this.marqueeAnimation, this.marqueeTiming );
					this.animations.push( animation );
				}
			}

			slowDownAnimations() {
				// console.log('Slowing down animations');
				for ( const animation of this.animations ) {
					animation.playbackRate = this.SLOWDOWN_RATE;
				}
			}

			resumeAnimationSpeed() {
				// console.log('Resuming animation speed');
				for ( const animation of this.animations ) {
					animation.playbackRate = 1; // Reset playback rate to normal
				}
			}

			cloneMarqueeGroup() {
				// console.log('Cloning marquee groups');
				const marqueeGroups = this.el.querySelectorAll( '.marquee__group' );
				marqueeGroups.forEach( ( group ) => {
					const items = group.querySelectorAll( '.cta-slider__slide' );
					const itemCount = items.length;
					const cloneCount = itemCount < 5 ? 3 : 1;

					// for ( let i = 0; i < cloneCount; i++ ) {
					// 	items.forEach( ( item ) => {
					// 		const clonedItem = item.cloneNode( true );
					// 		group.appendChild( clonedItem );
					// 	} );
					// }
				} );

				const firstGroup = this.el.querySelector( '.marquee__group' );
				const clone = firstGroup.cloneNode( true );
				clone.classList.add( 'clone' );
				this.el.appendChild( clone );

				this.marquee__groups = Array.from( this.el.querySelectorAll( '.marquee__group' ) );
				// console.log('Marquee groups:', this.marquee__groups);
			}
		}

		const sliders = Array.from( document.querySelectorAll( '.cta-section__sliders--slider.marquee' ) );
		// console.log('Sliders found:', sliders);
		sliders.forEach( ( slider, index ) => {
			const reverse = index === 1;
			new MarqueeSlider( { el: slider, reverse } );
		} );
	}

	if ( jQuery( '.job-title' ).length > 0 ) {
		jQuery( '.job-title' ).on( 'click', function() {
			if ( jQuery( this ).hasClass( 'active' ) ) {
				jQuery( this ).removeClass( 'active' );
				jQuery( this ).closest( '.job-filter-category' ).removeClass( 'active' );
				jQuery( this ).siblings( '.job-filter-checkboxes' ).slideUp( 300 );
			} else {
				jQuery( '.job-title' ).removeClass( 'active' );
				jQuery( '.job-filter-category' ).removeClass( 'active' );
				jQuery( this ).closest( '.job-filter-category' ).addClass( 'active' );
				jQuery( '.job-filter-checkboxes' ).slideUp( 300 );
				jQuery( this ).addClass( 'active' );
				jQuery( this ).siblings( '.job-filter-checkboxes' ).slideDown( 300 );
			}
		} );
	}
	jQuery.noConflict();

	if ( jQuery( '.job-teaser-outer' ).length > 0 ) {
		jQuery( '.js-button__view--job-view button' ).on( 'click', function() {
			jQuery( '.js-buttons__view--grid' ).removeClass( 'is-active-view' );
			jQuery( this ).closest( '.js-buttons__view--list' ).addClass( 'is-active-view' );
		} );

		jQuery( '.js-buttons__view--grid button' ).on( 'click', function() {
			jQuery( '.job-results-view ' ).addClass( 'js-grid-view-result no-transition' );
			jQuery( '.js-buttons__view--list' ).removeClass( 'is-active-view' );
			jQuery( this ).closest( '.js-buttons__view--grid' ).addClass( 'is-active-view' );

			setTimeout( () => {
				jQuery( '.job-results-view ' ).removeClass( 'no-transition' );
			}, 500 );
		} );

		jQuery( '.js-buttons__view--list button' ).on( 'click', function() {
			jQuery( '.job-results-view ' ).removeClass( 'js-grid-view-result ' );
			jQuery( '.job-results-view ' ).addClass( 'no-transition' );

			setTimeout( () => {
				jQuery( '.job-results-view ' ).removeClass( 'no-transition' );
			}, 500 );
		} );

		if ( jQuery( '.job-teaser-filter' ).length > 0 ) {
			const filterHeight = jQuery( '.job-teaser-filter' ).outerHeight();
			jQuery( '.job-teaser-outer' ).css( 'min-height', filterHeight + 'px' );
		}

		// jQuery( document ).on( 'click', '.hide-filter-button', function() {
		// 	const $container = jQuery( '.job-offers' );

		// 	// Unwrap existing rows
		// 	$container.find( '.row' ).contents().unwrap();

		// 	// Wrap items into rows of three
		// 	wrap3( $container );
		// } );

		// jQuery( document ).on( 'click', '.js-buttons__filter', function() {
		// 	const $button = jQuery( this );
		// 	const $inner = $button.find( '.js-button-filter-text' );
		// 	const innerText = $inner.text().trim();
		// 	jQuery( '.job-results-view' ).toggleClass( 'is-filter-showing' );
		// 	jQuery( this ).toggleClass( 'hide-filter-button' );

		// 	if ( innerText === 'Hide Filters' ) {
		// 		$inner.text( 'Show Filters' );
		// 		// Apply wrap3 function
		// 		const $container = jQuery( '.job-offers' );
		// 		// Unwrap existing rows
		// 		$container.find( '.row' ).contents().unwrap();
		// 		// Wrap items into rows of three
		// 		wrap3( $container );
		// 	} else {
		// 		$inner.text( 'Hide Filters' );
		// 		// Apply wrap2 function
		// 		const $container = jQuery( '.job-offers' );
		// 		// Unwrap existing rows
		// 		$container.find( '.row' ).contents().unwrap();
		// 		// Wrap items into rows of two
		// 		wrap2( $container );
		// 	}
		// } );

		// function wrap3( $container ) {
		// 	$container.each( function() {
		// 		const outerBoxes = jQuery( this ).find( '.outer-box' );
		// 		let currentIndex = 0;

		// 		while ( currentIndex < outerBoxes.length ) {
		// 			let endIndex = currentIndex + 3;
		// 			if ( endIndex > outerBoxes.length ) {
		// 				endIndex = outerBoxes.length;
		// 			}
		// 			const elementsToWrap = outerBoxes.slice( currentIndex, endIndex );
		// 			elementsToWrap.wrapAll( '<div class="row"></div>' );
		// 			currentIndex = endIndex;
		// 		}
		// 	} );
		// }

		// function wrap2( $container ) {
		// 	$container.each( function() {
		// 		const outerBoxes = jQuery( this ).find( '.outer-box' );
		// 		let currentIndex = 0;

		// 		while ( currentIndex < outerBoxes.length ) {
		// 			let endIndex = currentIndex + 2;
		// 			if ( endIndex > outerBoxes.length ) {
		// 				endIndex = outerBoxes.length;
		// 			}
		// 			const elementsToWrap = outerBoxes.slice( currentIndex, endIndex );
		// 			elementsToWrap.wrapAll( '<div class="row"></div>' );
		// 			currentIndex = endIndex;
		// 		}
		// 	} );
		// }

		// wrap3( jQuery( '.job-offers' ) );
	}

	if ( ( jQuery( '.tabbed-repeater' ).length > 0 ) || ( jQuery( '.scrolling-content' ).length > 0 ) && jQuery( window ).width() >= 1004 ) {
		function changeBodyColor( colorClass ) {
			jQuery( 'body' ).removeClass( 'lblue-mode orange-mode mode-last' );
			jQuery( 'body' ).addClass( colorClass );
		}

		const scrollTriggers = [
			{
				trigger: '.no-mode',
				start: 'top 100px',
				end: 'bottom 30%',
				colorEnter: 'no-mode',
				colorLeaveBack: 'no-mode',
			},
			{
				trigger: '.mode-01',
				start: 'top 100px',
				end: 'bottom 30%',
				colorEnter: 'lblue-mode ',
				colorLeaveBack: 'lblue-mode',
			},
			{
				trigger: '.mode-02',
				start: 'top 100px',
				end: 'bottom 30%',
				colorEnter: 'orange-mode',
				colorLeaveBack: 'orange-mode',
			},
			{
				trigger: '.mode-03',
				start: 'top 100px',
				end: 'bottom 30%',
				colorEnter: 'lblue-mode',
				colorLeaveBack: 'lblue-mode',
			},
			{
				trigger: '.mode-04',
				start: 'top 100px',
				end: 'bottom 30%',
				colorEnter: 'orange-mode',
				colorLeaveBack: 'orange-mode',
			},
			{
				trigger: '.mode-05',
				start: 'top 100px',
				end: 'bottom 30%',
				colorEnter: 'lblue-mode',
				colorLeaveBack: 'lblue-mode',
			},
			{
				trigger: '.mode-06',
				start: 'top 100px',
				end: 'bottom 30%',
				colorEnter: 'orange-mode',
				colorLeaveBack: 'orange-mode',
			},
			{
				trigger: '.mode-last',
				start: 'top 50%',
				end: 'bottom 30%',
				colorEnter: 'mode-last',
				colorLeaveBack: 'mode-last',

			},
		];

		scrollTriggers.forEach( function( config ) {
		// Check if the trigger element exists
			if ( jQuery( config.trigger ).length > 0 ) {
				gsap.to( config.trigger, {
					scrollTrigger: {
						trigger: config.trigger,
						start: config.start,
						end: config.end,
						// markers: true,
						onEnter: () => {
							changeBodyColor( config.colorEnter );
						},
						onLeaveBack: () => {
							changeBodyColor( config.colorLeaveBack );
						},
					},
				} );
			}
		} );
	}

	if ( jQuery( '.fixed-button' ).length > 0 ) {
		gsap.to( '.fixed-button', {
			duration: 1,
			scrollTrigger: {
				trigger: '.footer-section',
				start: 'top 100% top',
				end: 'top 100% top',
				// markers: true,
				onEnter: () => {
					jQuery( '.fixed-button' ).addClass( 'hide' );
				},
				onLeaveBack: () => {
					jQuery( '.fixed-button' ).removeClass( 'hide' );
				},
			},
		} );
	}

	if ( jQuery( '.video-block' ).length > 0 ) {
		gsap.to( '.video-block', {
			duration: 1,
			scrollTrigger: {
				trigger: '.video-block-end-trigger',
				start: 'top 40% top',
				// end: 'top top',
				// markers: true,
				onEnter: () => {
					jQuery( '.video-block' ).addClass( 'show-controls' );
					jQuery( '.video__popup--iframe' ).fadeIn( 'slow' );
				},
			},
		} );
	}

	if ( jQuery( '.play-button' ).length > 0 ) {
		jQuery( '.play-button' ).on( 'click', function() {
			jQuery( this ).fadeOut( 'slow' );
		} );
	}

	if ( jQuery( '#myCustomVideo' ).length > 0 ) {
		const video = jQuery( '#myCustomVideo' );
		const playButton = jQuery( '.play-button' );
		playButton.on( 'click', togglePlayPause );
		function togglePlayPause() {
			if ( video[ 0 ].paused ) {
				video[ 0 ].play();
			} else {
				video[ 0 ].pause();
			}
		}
		function stopVideo() {
			video[ 0 ].pause();
		}
	}

	jQuery( document.body ).on( 'click', function( e ) {
		if ( ! jQuery( e.target ).closest( '.banner-search' ).length ) {
			jQuery( 'body' ).addClass( 'hide-search-results' );
			// jQuery( 'html' ).addClass( 'hide-search-results' );
		} else {
			// jQuery( 'html' ).removeClass( 'hide-search-results' );
		}
	} );

	jQuery.noConflict();
} );
